import React, {useEffect} from "react";
import styled from "styled-components";
import {media} from "assets/css/media";
import {useDispatch, useSelector} from "react-redux";
import {getPreDrawResults} from "apps/DRAW_PREDICTOR/modules/selectors";
import resultBg from "apps/DRAW_PREDICTOR/assets/images/predraw/resultBg.svg";
import resultBgMobile from "apps/DRAW_PREDICTOR/assets/images/predraw/resultBgMobile.svg";
import {ReactComponent as Lock} from "apps/DRAW_PREDICTOR/assets/images/predraw/Lock.svg";
import {ReactComponent as Swap} from "apps/DRAW_PREDICTOR/assets/images/predraw/swap.svg";
import squadBg from "apps/DRAW_PREDICTOR/assets/images/predraw/resultSquadbg.svg";
import {Exist, PureButton} from "components";
import {editPreDraw} from "apps/DRAW_PREDICTOR/modules/actions";
import {FLAGS_URL} from "apps/DRAW_PREDICTOR/modules/constants";

const Wrapper = styled.div`
	@media (max-width: ${media.mobile}) {
		padding: 0 20px;
	}
	@media (max-width: 375px) {
		padding: 0 15px;
	}
`;

const Results = styled.section`
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 20px;
	@media (max-width: ${media.mobile}) {
		margin-bottom: 20px;
	}
	@media (max-width: 375px) {
		gap: 10px;
		justify-content: center;
	}
`;

const Squad = styled.div`
	background: url(${resultBg}) 0 0 no-repeat;
	width: 100px;
	height: 155px;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	background-size: cover;
	@media (max-width: ${media.mobile}) {
		background: url(${resultBgMobile}) 0 0 no-repeat;
		width: 77px;
		height: 123px;
	}
	@media (max-width: 375px) {
	}
`;
const SquadData = styled.div`
	width: 65px;
	height: 83px;
	background: url(${squadBg}) center no-repeat;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	margin: 5px auto;
	background-size: cover;
	@media (max-width: ${media.mobile}) {
		width: 55px;
		height: 65px;
		> svg {
			width: 70%;
		}
	}
`;

const SquadName = styled.p`
	font-family: "Qatar2022";
	font-size: 16px;
	line-height: 160%;
	font-weight: 500;
	color: #000;
	margin-top: 5px;
	text-align: center;
	@media (max-width: 375px) {
		font-size: 14px;
	}
`;

const SquadRank = styled.p`
	font-family: "Qatar2022";
	font-weight: 500;
	font-size: 14px;
	line-height: 160%;
	text-align: center;
`;

const SwapButton = styled(PureButton)`
	@media (max-width: ${media.mobile}) {
		height: 20px;
		> svg {
			height: 20px;
		}
	}
`;
const Icons = styled.div`
	@media (max-width: 375px) {
		svg {
			width: 24px;
			height: 24px;
		}
	}
`;

const Flag = styled.div`
	width: 49px;
	img {
		width: auto;
		max-width: 100%;
	}
	@media (max-width: ${media.mobile}) {
		width: 44px;
	}
	@media (max-width: 320px) {
		height: 30px;
	}
`;

export const PreDrawResults: React.FC = () => {
	const squads = useSelector(getPreDrawResults);
	const dispatch = useDispatch();

	const edit = () => {
		dispatch(editPreDraw());
	};
	useEffect(() => {
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	});

	return (
		<Wrapper>
			<Results>
				{squads.map((squad) => {
					const imageUrl = `${FLAGS_URL}${squad.shortName}.png`;
					return (
						<Squad key={squad.id}>
							<SquadRank>{squad.rank || "N/A"}</SquadRank>
							<SquadData>
								<Flag>
									<img src={imageUrl} alt={squad.name} />
								</Flag>
								<SquadName>{squad.shortName}</SquadName>
							</SquadData>
							<Icons>
								<Exist when={squad.is_qualified}>
									<Lock />
								</Exist>
								<Exist when={!squad.is_qualified}>
									<SwapButton onClick={edit}>
										<Swap />
									</SwapButton>
								</Exist>
							</Icons>
						</Squad>
					);
				})}
			</Results>
		</Wrapper>
	);
};
